/*
 * @Description:埋点接口
 * @Author: lyy
 * @Date: 2022-08-25 17:42:43
 * @LastEditors: your Name
 * @LastEditTime: 2022-08-26 16:41:03
 */
import $axios from "@/utils/$axios";
const useApi = {
    recordPushDataUrl: "/recordPushCloud/recordPushData"
};
export function recordPushDataFn(data){
    return $axios({
        url: useApi.recordPushDataUrl,
        method: "post",
        headers: {
            "Content-Type": "application/json"
          },
        data
      });
}